var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommercial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1038_1388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7999 30.6667L2.6332 17.5L12.6999 7.43333L17.5665 12.3L18.4999 11.3667L11.3665 4.23333L2.26654 13.3333L3.56654 14.6333L1.66654 16.5333L-1.4668 13.4L11.4332 0.5L15.5665 4.63333L19.6999 0.5L32.8332 13.6333L15.7999 30.6667ZM15.8332 26.9333L29.0665 13.6333L19.6665 4.23333L17.4332 6.46667L22.2999 11.3333L17.5665 16.0667L12.6999 11.2L6.39987 17.5L7.36654 18.4667L12.3332 13.5L14.1999 15.3667L9.2332 20.3333L10.1665 21.2667L15.1332 16.3L17.0332 18.2L12.0665 23.1667L12.9999 24.1L17.9665 19.1333L19.8332 21L14.8665 25.9667L15.8332 26.9333Z",
    fill: "#1955DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1038_1388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercial);
export default __webpack_public_path__ + "static/media/commercial.07145a1636235af8018e42a00aaa426d.svg";
export { ForwardRef as ReactComponent };